import React from 'react';
import { Text } from './styles';

export function Typography({type, ...rest}) {
  return <Text type={type} { ...rest }/>
}